import React from 'react';
import { motion } from 'framer-motion';
import './Offerings.css';

const Offerings = () => {
  const offerings = [
    {
      title: 'Hatha Yoga',
      icon: '🧘',
      desc: 'Build strength and flexibility.',
      img: 'https://images.unsplash.com/photo-1599901860904-17e6ed7083a0?auto=format&fit=crop&q=80&w=800'
    },
    {
      title: 'Vinyasa Flow',
      icon: '🌿',
      desc: 'Move with breath and energy.',
      img: 'https://images.unsplash.com/photo-1518611012118-696072aa579a?auto=format&fit=crop&q=80&w=800'
    },
    {
      title: 'Meditation',
      icon: '🕉',
      desc: 'Find calm and inner balance.',
      img: 'https://images.unsplash.com/photo-1508672019048-805c876b67e2?auto=format&fit=crop&q=80&w=800'
    },
    {
      title: 'Online Classes',
      icon: '💻',
      desc: 'Practice from anywhere.',
      img: 'https://images.unsplash.com/photo-1603988363607-e1e4a66962c6?auto=format&fit=crop&q=80&w=800'
    },
    {
      title: 'Corporate Yoga',
      icon: '🏢',
      desc: 'Wellness programs for teams.',
      img: 'https://images.unsplash.com/photo-1552581234-26160f608093?auto=format&fit=crop&q=80&w=800'
    },
    {
      title: 'Private Sessions',
      icon: '👤',
      desc: 'One-on-one personalized guidance.',
      img: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?auto=format&fit=crop&q=80&w=800'
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { staggerChildren: 0.15 } }
  };

  const itemVariants = {
    hidden: { opacity: 0, scale: 0.95, y: 20 },
    visible: { opacity: 1, scale: 1, y: 0, transition: { duration: 0.6 } }
  };

  return (
    <section className="offerings">
      <div className="offerings-container">
        
        <motion.div 
          className="offerings-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6 }}
        >
          <h4 className="offerings-subtitle">Our Offerings</h4>
          <h2 className="offerings-title">Yoga for Every Lifestyle</h2>
          <p className="offerings-desc">
            Choose the practice that fits your goals and schedule.
          </p>
          <div className="offerings-divider"></div>
        </motion.div>

        <motion.div 
          className="offerings-grid"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          {offerings.map((offering, idx) => (
            <motion.div key={idx} className="offering-card" variants={itemVariants}>
              <div className="offering-img-wrapper">
                <img src={offering.img} alt={offering.title} className="offering-img" />
                <div className="offering-overlay">
                  <div className="offering-icon">{offering.icon}</div>
                </div>
              </div>
              
              <div className="offering-content">
                <h3 className="offering-card-title">{offering.title}</h3>
                <p className="offering-card-desc">{offering.desc}</p>
                <div className="offering-link">
                  <span>Learn More</span>
                  <span className="arrow">→</span>
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>

      </div>
    </section>
  );
};

export default Offerings;
